export const certificationItems = [
  {
    title: 'Лицензия МЧС России',
    subtitle: 'Монтаж, ремонт и техническое обслуживание',
    description:
      'Работы со средствами обеспечения пожарной безопасности зданий и сооружений, включая ввод систем в эксплуатацию и последующее сопровождение.',
  },
  {
    title: 'Лицензия МЧС России',
    subtitle: 'Тушение пожаров',
    description:
      'Право на выполнение работ по тушению пожаров в населенных пунктах, на производственных объектах и объектах инфраструктуры.',
  },
  {
    title: 'Лицензия Министерства образования и науки Самарской области',
    subtitle: 'Образовательная деятельность',
    description:
      'Проведение профильного обучения и подготовки персонала по программам, связанным с вопросами пожарной безопасности.',
  },
  {
    title: 'Свидетельство АСС',
    subtitle: 'Поисково-спасательные и аварийно-спасательные работы',
    description:
      'Подтверждение компетенций для участия в аварийно-спасательных мероприятиях и работах повышенной ответственности.',
  },
  {
    title: 'Свидетельство ГУ МЧС России',
    subtitle: 'Обследование объектов и расчет пожарных рисков',
    description:
      'Проведение обследований объектов защиты, расчетов пожарных рисков и подготовка обоснований по требованиям безопасности.',
  },
  {
    title: 'Аккредитация НСОПБ',
    subtitle: 'Проверка работоспособности систем',
    description:
      'Испытания и оценка работоспособности систем и средств противопожарной защиты в течение срока их эксплуатации.',
  },
  {
    title: 'СРО',
    subtitle: 'Проектирование, изыскания, строительство',
    description:
      'Подготовка проектной документации, инженерные изыскания, строительство, реконструкция и капитальный ремонт объектов.',
  },
  {
    title: 'Система менеджмента качества',
    subtitle: 'ISO 9001, ISO 14001, OHSAS 18001',
    description:
      'Работа по регламентированным стандартам качества, охраны труда и экологического менеджмента.',
  },
];

const gallerySets = {
  fireSafety: [
    {
      src: '/images/Москва совещание.jpg',
      alt: 'Рабочее совещание по вопросам пожарной безопасности',
    },
    {
      src: '/images/Москва (1).jpg',
      alt: 'Профильное мероприятие по вопросам безопасности',
    },
    {
      src: '/images/Москва (2).jpg',
      alt: 'Обсуждение инженерных решений и нормативных требований',
    },
    {
      src: '/images/Москва (5)ретуш.jpg',
      alt: 'Специалисты на отраслевой встрече',
    },
  ],
  fireGuard: [
    {
      src: '/images/IMG_20240207_100553.jpg',
      alt: 'Пожарный расчет на дежурстве',
    },
    {
      src: '/images/IMG_20240207_100558.jpg',
      alt: 'Пожарная техника и расчет на объекте',
    },
    {
      src: '/images/IMG_20240207_100627.jpg',
      alt: 'Обеспечение пожарной охраны на производственной площадке',
    },
    {
      src: '/images/IMG_20240207_100655.jpg',
      alt: 'Дежурство пожарного расчета на территории предприятия',
    },
  ],
  constructionWorks: [
    {
      src: '/images/photo_2026-03-03_17-12-20.jpg',
      alt: 'Строительно-монтажные работы на объекте',
    },
    {
      src: '/images/photo_2026-03-03_17-11-58.jpg',
      alt: 'Здание и площадка для проектных и строительных работ',
    },
    {
      src: '/images/photo_2026-03-03_17-12-12.jpg',
      alt: 'Работы по проектированию и строительной подготовке объекта',
    },
  ],
  securitySystems: [
    {
      src: 'https://images.pexels.com/photos/12045663/pexels-photo-12045663.jpeg?auto=compress&cs=tinysrgb&w=1200',
      alt: 'Спринклерный узел и пожарная автоматика на объекте',
    },
    {
      src: 'https://images.pexels.com/photos/14860386/pexels-photo-14860386.jpeg?auto=compress&cs=tinysrgb&w=1200',
      alt: 'Пожарная сигнализация на фасаде здания',
    },
    {
      src: 'https://images.pexels.com/photos/6682880/pexels-photo-6682880.jpeg?auto=compress&cs=tinysrgb&w=1200',
      alt: 'Система контроля доступа на входе',
    },
    {
      src: 'https://images.pexels.com/photos/18934462/pexels-photo-18934462.jpeg?auto=compress&cs=tinysrgb&w=1200',
      alt: 'Камеры видеонаблюдения на здании',
    },
  ],
  engineeringInfrastructure: [
    {
      src: 'https://images.pexels.com/photos/4508748/pexels-photo-4508748.jpeg?auto=compress&cs=tinysrgb&w=1200',
      alt: 'Оптические кабели в телекоммуникационном шкафу',
    },
    {
      src: 'https://images.pexels.com/photos/2881229/pexels-photo-2881229.jpeg?auto=compress&cs=tinysrgb&w=1200',
      alt: 'Структурированная кабельная сеть в серверном оборудовании',
    },
    {
      src: 'https://images.pexels.com/photos/28950842/pexels-photo-28950842.jpeg?auto=compress&cs=tinysrgb&w=1200',
      alt: 'Электрический щит с автоматическими выключателями',
    },
    {
      src: 'https://images.pexels.com/photos/28942196/pexels-photo-28942196.jpeg?auto=compress&cs=tinysrgb&w=1200',
      alt: 'Внутренняя компоновка электрического контрольного шкафа',
    },
  ],
  equipmentSupply: [
    {
      src: '/images/photo_2026-04-09_23-35-24.jpg',
      alt: 'Огнетушители и пожарное оборудование',
    },
    {
      src: '/images/Арго (11).jpeg',
      alt: 'Показ огнетушителя и пожарного оборудования',
    },
    {
      src: '/images/Арго рукав.jpg',
      alt: 'Пожарный рукав и комплектующие',
    },
    {
      src: '/images/Арго заправка.jpg',
      alt: 'Работы с пожарным оборудованием',
    },
  ],
  waterTests: [
    {
      src: '/images/Арго вода.jpg',
      alt: 'Испытания по водоотдаче на объекте',
    },
    {
      src: '/images/Арго заправка.jpg',
      alt: 'Подключение техники и испытания водоснабжения',
    },
    {
      src: '/images/Арго рукав.jpg',
      alt: 'Подготовка пожарного рукава к работам',
    },
    {
      src: '/images/учения1.jpg',
      alt: 'Полевые испытания систем водоснабжения',
    },
  ],
  ventilation: [
    {
      src: 'https://images.pexels.com/photos/11538226/pexels-photo-11538226.jpeg?auto=compress&cs=tinysrgb&w=1200',
      alt: 'Воздуховод приточной вентиляции в промышленном помещении',
    },
    {
      src: 'https://images.pexels.com/photos/29086539/pexels-photo-29086539.jpeg?auto=compress&cs=tinysrgb&w=1200',
      alt: 'Внешний вентиляционный канал на фасаде здания',
    },
    {
      src: 'https://images.pexels.com/photos/8297856/pexels-photo-8297856.jpeg?auto=compress&cs=tinysrgb&w=1200',
      alt: 'Вентиляционные каналы под потолком здания',
    },
    {
      src: 'https://images.pexels.com/photos/19431067/pexels-photo-19431067.jpeg?auto=compress&cs=tinysrgb&w=1200',
      alt: 'Наружный вентиляционный короб на техническом фасаде',
    },
  ],
  streletsMonitoring: [
    {
      src: 'https://strelec-monitoring.ru/images/rspi%204-crop-u905.jpg?crc=3794404392',
      alt: 'Оборудование РСПИ Стрелец-Мониторинг',
    },
    {
      src: 'https://u-net.ru/sites/default/files/styles/780x/public/2026-01/%D0%B1%D0%B0%D0%BD%D0%BD%D0%B5%D1%80.jpg?itok=9qcbUBvp',
      alt: 'Станция объектовая Стрелец-Мониторинг внутри шкафа',
    },
    {
      src: 'https://fort-expert.ru/upload/iblock/cf6/cf691cdd9f4b84d564572454e21676e0.png',
      alt: 'Комплект оборудования для подключения к Стрелец-Мониторинг',
    },
    {
      src: 'https://bastion24.com/upload/iblock/55f/n7wxuw06ul75eu1a9t1gh94iw4w9ik3y.jpg',
      alt: 'Объектовая станция Стрелец-Мониторинг',
    },
  ],
  fireProtection: [
    {
      src: '/images/Таркетт пурга (2).jpg',
      alt: 'Промышленный объект для проведения специальных работ',
    },
    {
      src: '/images/Таркетт пурга (6).jpg',
      alt: 'Рабочая зона на промышленной площадке',
    },
    {
      src: '/images/Таркетт пурга (7).jpg',
      alt: 'Конструкции объекта в процессе обеспечения безопасности',
    },
    {
      src: '/images/Таркетт люди (1).jpg',
      alt: 'Специалисты на производственной площадке',
    },
  ],
};

export const servicesCatalog = [
  {
    number: '01',
    slug: 'pozharnaya-bezopasnost',
    title: 'Услуги в области пожарной безопасности',
    summary:
      'Подготавливаем документацию, проводим расчеты и аудит, сопровождаем объекты по вопросам нормативного соответствия.',
    cardPoints: [
      'Декларации пожарной безопасности и расчеты рисков',
      'Независимая оценка пожарного риска',
      'Противопожарные мероприятия, СТУ и концепции',
    ],
    lead:
      'Помогаем заказчикам привести документацию и технические решения в соответствие с действующими требованиями и обосновать безопасность объекта.',
    includedWorks: [
      'Оформление деклараций пожарной безопасности.',
      'Расчет пожарных рисков для объектов различного назначения.',
      'Независимая оценка пожарного риска и пожарный аудит.',
      'Разработка перечней противопожарных мероприятий.',
      'Подготовка технических условий и специальных технических условий.',
      'Разработка противопожарных концепций и экспертных заключений.',
      'Сопровождение согласований и консультации по устранению замечаний.',
    ],
    resultList: [
      'Понимание реального состояния объекта по части пожарной безопасности.',
      'Готовый пакет документов для эксплуатации, проектирования или реконструкции.',
      'Обоснованные решения для нестандартных архитектурных и технологических объектов.',
      'Снижение рисков штрафов, предписаний и задержек при вводе объекта.',
    ],
    productText: [
      'Документация по пожарной безопасности нужна на этапе строительства, реконструкции, эксплуатации и при подготовке к проверкам. Мы помогаем заказчику увидеть реальное состояние объекта, оформить необходимые материалы и выбрать решения, которые можно внедрить без лишних переделок.',
      'Работа строится вокруг практической пользы: расчеты, декларации, аудит, специальные технические условия и консультации помогают снизить риски, подготовить объект к эксплуатации и увереннее взаимодействовать с надзорными органами.',
    ],
    gallery: gallerySets.fireSafety,
  },
  {
    number: '02',
    slug: 'pozharnaya-ohrana',
    title: 'Пожарная охрана в системе ВДПО',
    summary:
      'Организуем объектовую пожарную охрану и обеспечиваем дежурство пожарных расчетов на предприятиях и мероприятиях.',
    cardPoints: [
      'Объектовая пожарная охрана',
      'Дежурство пожарных расчетов на автомобилях',
      'Поддержка пожароопасных и массовых мероприятий',
    ],
    lead:
      'Предоставляем пожарные расчеты, технику и организационное сопровождение для объектов, где требуется постоянное или временное присутствие профессиональной пожарной охраны.',
    includedWorks: [
      'Организация объектовой пожарной охраны на предприятии.',
      'Постановка пожарных расчетов на дежурство с техникой и оборудованием.',
      'Сопровождение огневых, пожароопасных и общественно-массовых мероприятий.',
      'Проверка готовности средств пожаротушения на объекте.',
      'Взаимодействие с ответственными службами и администрацией объекта.',
      'Проведение инструктажей и консультаций по действиям персонала.',
    ],
    resultList: [
      'Дополнительный уровень пожарной защиты для объекта или мероприятия.',
      'Быстрая реакция на инциденты и постоянный контроль рисковых зон.',
      'Повышение готовности персонала и руководства к нештатным ситуациям.',
      'Подтвержденный опыт работы на производственных и общественных площадках.',
    ],
    productText: [
      'Пожарная охрана востребована на производственных площадках, складах, массовых мероприятиях и объектах с повышенной пожарной нагрузкой. Дежурный расчет с техникой усиливает защиту объекта и помогает контролировать риски во время работ или мероприятий.',
      'Мы подбираем формат дежурства под режим объекта: постоянное присутствие, временное сопровождение, контроль пожароопасных работ или поддержка мероприятий. Заказчик получает готовый расчет, понятную схему взаимодействия и оперативную готовность на площадке.',
    ],
    gallery: gallerySets.fireGuard,
  },
  {
    number: '03',
    slug: 'stroitelno-montazhnye-raboty',
    title: 'Проектирование зданий и сооружений и СМР любой сложности',
    summary:
      'Проектируем здания и сооружения, выполняем строительно-монтажные работы и увязываем строительную часть с инженерными системами.',
    cardPoints: [
      'Проектирование зданий и сооружений',
      'Строительно-монтажные работы любой сложности',
      'Координация строительных и инженерных разделов',
    ],
    lead:
      'Сопровождаем объект от проектных решений до выполнения строительно-монтажных работ, учитывая назначение здания, требования безопасности, инженерные сети и условия эксплуатации.',
    includedWorks: [
      'Разработка проектных решений для зданий и сооружений.',
      'Подготовка строительной части под монтаж инженерных систем.',
      'Общестроительные и строительно-монтажные работы на действующих и строящихся объектах.',
      'Увязка архитектурно-строительных решений с электроснабжением, вентиляцией, автоматикой и системами безопасности.',
      'Организация работ на площадке, контроль качества и ведение исполнительной документации.',
      'Сопровождение объекта до готовности к дальнейшему запуску и эксплуатации.',
    ],
    resultList: [
      'Единая логика проектирования, строительства и инженерного оснащения объекта.',
      'Меньше конфликтов между строительной частью и смежными инженерными разделами.',
      'Понятная организация работ на площадке и контроль результата на каждом этапе.',
      'Готовность объекта к монтажу, наладке и дальнейшей эксплуатации.',
    ],
    productText: [
      'Проектирование и СМР особенно важны на объектах, где строительные решения напрямую связаны с безопасностью, инженерией и дальнейшей эксплуатацией здания. Мы учитываем реальные условия площадки, требования к надежности, доступность для обслуживания и последовательность выполнения работ.',
      'Такой формат удобен заказчику: проектные решения, строительные работы и инженерная часть согласуются внутри одного процесса. Это помогает сократить переделки, удержать сроки и получить объект, который готов к следующему этапу без лишних технических разрывов.',
    ],
    gallery: gallerySets.constructionWorks,
  },
  {
    number: '04',
    slug: 'kompleksnye-sistemy-bezopasnosti',
    aliases: ['tekhnicheskoe-obsluzhivanie-sistem'],
    title:
      'Проектирование, монтаж и обслуживание комплексных систем безопасности',
    summary:
      'Создаем и сопровождаем системы пожарной, охранной и инженерной безопасности от проекта до планового обслуживания.',
    cardPoints: [
      'Проектирование, комплектация и монтаж систем',
      'Пожарная автоматика, СОУЭ, дымоудаление и пожаротушение',
      'Регулярное техническое обслуживание и модернизация',
    ],
    lead:
      'Проектный отдел, монтажные подразделения и сервисные специалисты ВДПО ведут систему безопасности как единый жизненный цикл: обследование, проект, поставка, монтаж, пусконаладка и дальнейшее обслуживание.',
    includedWorks: [
      'Обследование объекта и подготовка технических решений.',
      'Проектирование систем пожарной сигнализации, оповещения, пожаротушения, дымоудаления, видеонаблюдения, охранной сигнализации и контроля доступа.',
      'Комплектация оборудования, монтаж, пусконаладка и подготовка исполнительной документации.',
      'Проверка сценариев работы систем и готовности к эксплуатации.',
      'Плановое техническое обслуживание пожарной автоматики, СОУЭ, систем пожаротушения, дымоудаления и охранных комплексов.',
      'Модернизация, замена устаревших элементов и консультации по дальнейшему развитию систем.',
    ],
    resultList: [
      'Единая система безопасности, спроектированная под особенности объекта.',
      'Один ответственный подрядчик за проект, монтаж, запуск и обслуживание.',
      'Стабильная работа оборудования и своевременное выявление неисправностей.',
      'Готовность объекта к эксплуатации, внутреннему контролю и проверкам.',
    ],
    designCapabilities: [
      'Системы автоматической пожарной сигнализации.',
      'Системы оповещения и управления эвакуацией при пожаре.',
      'Системы автоматического пожаротушения всех основных типов.',
      'Внутренний противопожарный водопровод и системы дымоудаления.',
      'Системы охранной сигнализации, видеонаблюдения и контроля доступа.',
      'Сети связи, СКС, ЛВС, серверная инфраструктура и локальные системы оповещения.',
    ],
    productText: [
      'Комплексные системы безопасности требуют согласованной работы проекта, оборудования, монтажа и сервисного обслуживания. Когда все этапы ведет одна команда, решения лучше стыкуются между собой, а объект быстрее выходит на стабильную эксплуатацию.',
      'Мы сопровождаем систему после запуска: проверяем оборудование, фиксируем состояние линий и приборов, помогаем планировать модернизацию и поддерживаем объект в готовности к штатным и нештатным ситуациям.',
    ],
    gallery: gallerySets.securitySystems,
  },
  {
    number: '05',
    slug: 'strukturirovannye-kabelnye-seti',
    aliases: ['elektrosnabzhenie', 'inzhenernye-sistemy-zdaniya'],
    title:
      'Инженерные системы, электроснабжение и структурированные кабельные сети',
    summary:
      'Проектируем и монтируем инженерную инфраструктуру здания: СКС, электроснабжение, связь, вентиляцию, отопление, водоснабжение и канализацию.',
    cardPoints: [
      'СКС, связь, радио, телевидение и локальные сети',
      'Электроснабжение, освещение и гарантированное питание',
      'Вентиляция, кондиционирование, отопление, ВК и канализация',
    ],
    lead:
      'Объединяем инженерные разделы в согласованную инфраструктуру, чтобы сети связи, электроснабжения, автоматики, вентиляции и водоснабжения работали без конфликтов и были удобны в эксплуатации.',
    includedWorks: [
      'Проектирование и монтаж структурированных кабельных сетей, локальных сетей, систем связи, радио и телевидения.',
      'Проектирование сетей внутреннего и наружного электроснабжения, электроосвещения, бесперебойного и гарантированного питания.',
      'Монтаж электротехнического оборудования, распределительных устройств и коммутационных узлов.',
      'Проектирование и монтаж систем вентиляции, кондиционирования, отопления, водоснабжения и канализации.',
      'Интеграция инженерных систем с автоматикой, диспетчеризацией и системами безопасности.',
      'Пусконаладка, маркировка линий, тестирование и подготовка исполнительной документации.',
    ],
    resultList: [
      'Согласованная инженерная инфраструктура для здания или производственной площадки.',
      'Стабильное питание и передача данных для технологических и защитных систем.',
      'Снижение количества пересечений между смежными разделами на монтаже.',
      'Удобство обслуживания, модернизации и дальнейшего расширения сетей.',
    ],
    productText: [
      'Инженерные системы лучше работают, когда проектируются не отдельными фрагментами, а как единая инфраструктура здания. СКС, электроснабжение, вентиляция, автоматика и системы безопасности должны быть увязаны по трассам, нагрузкам, доступу для обслуживания и режимам эксплуатации.',
      'Мы помогаем заказчику получить понятную и обслуживаемую инженерную основу объекта. Такой подход особенно полезен для административных зданий, производственных площадок, образовательных учреждений и объектов, где важны надежность, резервирование и возможность развития.',
    ],
    gallery: gallerySets.engineeringInfrastructure,
  },
  {
    number: '06',
    slug: 'postavka-i-perezaryadka-sredstv-pozharotusheniya',
    aliases: ['realizaciya-ognetushiteley-i-oborudovaniya'],
    title:
      'Поставка, реализация и перезарядка огнетушителей и пожарного оборудования',
    summary:
      'Комплектуем объекты огнетушителями, пожарным оборудованием, СИЗ и спасательными средствами, выполняем сервис и перезарядку.',
    cardPoints: [
      'Огнетушители, пожарное оборудование и принадлежности',
      'Средства индивидуальной защиты и спасательные средства',
      'Перезарядка, обслуживание и подбор под объект',
    ],
    lead:
      'Помогаем подобрать, поставить и поддерживать в исправном состоянии первичные средства пожаротушения, пожарное оборудование и средства защиты для объектов разного назначения.',
    includedWorks: [
      'Подбор огнетушителей по классу пожара, площади, назначению помещений и условиям эксплуатации.',
      'Поставка огнетушителей, пожарных шкафов, рукавов, стволов и сопутствующего оборудования.',
      'Комплектация постов, щитов пожарного инвентаря, объектов СИЗ и спасательными средствами.',
      'Перезарядка, проверка сроков годности и техническое обслуживание огнетушителей.',
      'Консультации по размещению, маркировке и дальнейшему сервисному сопровождению.',
      'Подготовка документации по обслуживанию и движению оборудования.',
    ],
    resultList: [
      'Объект укомплектован средствами пожаротушения под реальные риски и нормативные требования.',
      'Оборудование находится в исправном состоянии и имеет понятные сроки следующего обслуживания.',
      'Заказчик получает подбор, поставку и сервис в одном процессе.',
      'Снижается риск использования неподходящих, просроченных или несовместимых средств защиты.',
    ],
    productText: [
      'Огнетушители и пожарное оборудование должны не просто числиться на объекте, а быть правильно подобраны, размещены и готовы к применению. Мы учитываем назначение помещений, возможные классы пожара, условия хранения и дальнейшее обслуживание.',
      'Для организаций удобен комплексный формат: поставка, комплектация, перезарядка и контроль сроков выполняются в одном цикле. Это помогает поддерживать объект в порядке и не терять готовность между плановыми проверками.',
    ],
    gallery: gallerySets.equipmentSupply,
  },
  {
    number: '07',
    slug: 'ispytaniya-vodoprovoda',
    title:
      'Испытания на водоотдачу и давление наружного и внутреннего водопровода',
    summary:
      'Проводим испытания противопожарного водоснабжения, фиксируем показатели и оформляем результаты.',
    cardPoints: [
      'Наружный и внутренний водопровод',
      'Проверка давления и фактической водоотдачи',
      'Документальное оформление результатов',
    ],
    lead:
      'Проверяем способность системы водоснабжения обеспечить расчетный расход и давление для целей пожаротушения на конкретном объекте.',
    includedWorks: [
      'Подготовка схемы испытаний и выезд специалистов на объект.',
      'Испытания наружного противопожарного водопровода.',
      'Испытания внутреннего противопожарного водопровода.',
      'Измерение давления, расхода воды и фиксация результатов.',
      'Оценка состояния запорной арматуры, рукавных линий и точек отбора.',
      'Подготовка актов и рекомендаций по устранению недостатков.',
    ],
    resultList: [
      'Подтверждение фактической работоспособности противопожарного водоснабжения.',
      'Понимание слабых мест системы до возникновения аварийной ситуации.',
      'Документы для внутреннего контроля, эксплуатации и проверок.',
      'Основание для модернизации или ремонта водопроводной сети.',
    ],
    productText: [
      'Испытания противопожарного водопровода показывают, сможет ли система обеспечить нужный расход и давление в реальных условиях. Такая проверка помогает заранее выявить слабые участки, неисправную арматуру и проблемы, которые невозможно оценить только по проекту.',
      'По итогам работ заказчик получает зафиксированные показатели, акты и рекомендации. Это удобно для эксплуатации, внутреннего контроля, подготовки к проверкам и планирования ремонта или модернизации водопроводной сети.',
    ],
    gallery: gallerySets.waterTests,
  },
  {
    number: '08',
    slug: 'proverka-ventilyacii-i-dymohodov',
    title: 'Проверка вентиляции и дымоходов',
    summary:
      'Обследуем вентиляционные каналы и дымоходы, выявляем нарушения тяги, засоры и опасные дефекты.',
    cardPoints: [
      'Обследование каналов и шахт',
      'Проверка тяги и состояния конструкций',
      'Рекомендации по устранению нарушений',
    ],
    lead:
      'Проводим проверку систем вентиляции и дымоудаления для жилых, общественных и производственных объектов, где важна надежная и безопасная работа каналов.',
    includedWorks: [
      'Осмотр вентиляционных каналов и дымоходов.',
      'Проверка тяги и проходимости каналов.',
      'Выявление дефектов, засоров и нарушений герметичности.',
      'Оценка состояния оголовков, шахт и присоединений.',
      'Подготовка заключения и рекомендаций по устранению нарушений.',
      'Консультации по дальнейшей эксплуатации и профилактике.',
    ],
    resultList: [
      'Снижение риска задымления, обратной тяги и опасных режимов эксплуатации.',
      'Понимание реального состояния вентиляционных и дымовых каналов.',
      'Основа для ремонта, очистки или модернизации систем.',
      'Повышение безопасности пользователей здания и оборудования.',
    ],
    productText: [
      'Проверка вентиляции и дымоходов важна для зданий, где работают системы дымоудаления, газоиспользующее оборудование, кухни, котельные и другие помещения с повышенными требованиями к воздухообмену. Нарушения тяги и засоры каналов могут быстро стать причиной опасных режимов эксплуатации.',
      'Мы обследуем каналы, фиксируем состояние конструкций, проверяем тягу и даем понятные рекомендации. Это помогает собственникам и эксплуатирующим организациям вовремя устранять риски и поддерживать системы в рабочем состоянии.',
    ],
    gallery: gallerySets.ventilation,
  },
  {
    number: '09',
    slug: 'ognezashchita-materialov-i-konstrukciy',
    title: 'Работы по огнезащите материалов, изделий и конструкций',
    summary:
      'Выполняем огнезащитную обработку строительных конструкций и материалов с учетом требований проекта и эксплуатации.',
    cardPoints: [
      'Металлические и деревянные конструкции',
      'Материалы, изделия и инженерные узлы',
      'Подготовка основания и контроль качества работ',
    ],
    lead:
      'Подбираем технологию огнезащиты под тип конструкции, требуемый предел огнестойкости и условия дальнейшей эксплуатации объекта.',
    includedWorks: [
      'Обследование конструкций и подбор огнезащитных составов.',
      'Подготовка поверхностей к нанесению материалов.',
      'Огнезащитная обработка металлических и деревянных конструкций.',
      'Работы по огнезащите изделий, узлов и отдельных инженерных элементов.',
      'Контроль толщины и качества нанесения покрытия.',
      'Подготовка актов, паспортов и другой исполнительной документации.',
    ],
    resultList: [
      'Повышение огнестойкости конструкций и снижение риска быстрого развития пожара.',
      'Приведение объекта в соответствие с проектными и нормативными требованиями.',
      'Подтвержденный объем и качество огнезащитных работ.',
      'Готовность объекта к эксплуатации и проверкам после выполнения обработки.',
    ],
    productText: [
      'Огнезащита строительных конструкций и материалов помогает повысить предел огнестойкости и снизить скорость распространения опасных факторов пожара. Особенно важны такие работы для производственных объектов, складов, общественных зданий и площадок с металлическими или деревянными конструкциями.',
      'Мы подбираем состав и технологию нанесения под материал, условия эксплуатации и проектные требования. Заказчик получает выполненные работы с контролем качества и документальным подтверждением результата.',
    ],
    gallery: gallerySets.fireProtection,
  },
];

export const streletsMonitoringService = {
  title: 'Стрелец-Мониторинг',
  summary:
    'Подключаем пожарную автоматику объекта к системе передачи извещений для оперативной передачи сигнала о пожаре.',
  lead:
    'Система «Стрелец-Мониторинг» помогает быстро передать сигнал о пожаре с объекта на пульт пожарной охраны, контролировать состояние оборудования и повысить готовность объекта к оперативному реагированию.',
  cardPoints: [
    'Подключение к пульту централизованного наблюдения',
    'Передача сигнала о пожаре без участия персонала объекта',
    'Монтаж, настройка и дальнейшее обслуживание оборудования',
  ],
  includedWorks: [
    'Обследование объекта и проверка готовности пожарной сигнализации к подключению.',
    'Подбор объектового оборудования и подготовка технических решений.',
    'Монтаж станции передачи извещений и подключение к существующей пожарной автоматике.',
    'Настройка каналов связи, тестовая передача сигналов и проверка корректности работы.',
    'Подготовка исполнительной документации и сопровождение ввода системы в эксплуатацию.',
    'Техническое обслуживание, контроль состояния оборудования и консультации по эксплуатации.',
  ],
  resultList: [
    'Автоматическая передача сигнала о пожаре на пульт централизованного наблюдения.',
    'Сокращение времени между срабатыванием пожарной автоматики и реагированием служб.',
    'Контроль состояния элементов системы с сохранением информации о событиях.',
    'Понятный порядок обслуживания и поддержания оборудования в рабочем состоянии.',
  ],
  productText: [
    '«Стрелец-Мониторинг» применяют на объектах, где важно обеспечить надежную передачу тревожного сигнала и снизить зависимость от действий персонала. Система работает как связующее звено между пожарной автоматикой здания и пультом наблюдения, помогая быстрее передать информацию о событии.',
    'При подключении учитываются действующие системы пожарной сигнализации, назначение объекта, схема связи и требования к дальнейшему обслуживанию. Такой подход особенно актуален для школ, торговых центров, гостиниц, медицинских учреждений, бизнес-центров и других зданий с большим количеством людей.',
  ],
  gallery: gallerySets.streletsMonitoring,
};

export const serviceRequestOptions = [
  ...servicesCatalog.map((service) => service.title),
  streletsMonitoringService.title,
];
